import {
  EmailReceivingMethodData,
  InvoiceReceiveEmailProcessType,
} from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useMemo } from 'react';

export type EmailAddressRowConfig = {
  shouldShowCopyButton: boolean;
  isSecondaryText: boolean;
} | null;

type UseEmailAddressRowConfigParams = {
  data?: EmailReceivingMethodData;
};

/**
 * Hook to determine the display configuration for the email address row.
 * Returns null if the address row should not be displayed.
 */
export const useEmailAddressRowConfig = ({
  data,
}: UseEmailAddressRowConfigParams): EmailAddressRowConfig => {
  return useMemo(() => {
    const {
      invoice_receive_email_process_type,
      contact_office_member,
      is_invoice_receive_mail_address_issued,
    } = data || {};

    // Process type: Received invoice - always show with copy button
    if (
      invoice_receive_email_process_type ===
      InvoiceReceiveEmailProcessType.RECEIVED_INVOICE
    ) {
      return {
        shouldShowCopyButton: true,
        isSecondaryText: false,
      };
    }

    // Process type: Payment request
    if (
      invoice_receive_email_process_type ===
      InvoiceReceiveEmailProcessType.PAYMENT_REQUEST
    ) {
      const hasIssuedAddress =
        !!contact_office_member && !!is_invoice_receive_mail_address_issued;

      return {
        shouldShowCopyButton: hasIssuedAddress,
        isSecondaryText: !hasIssuedAddress,
      };
    }

    // Process type: Not set or unknown
    return {
      shouldShowCopyButton: false,
      isSecondaryText: false,
    };
  }, [data]);
};
